import { Component, OnInit } from '@angular/core';
import { SMS_HELP_URL } from '../../constants';

@Component({
  selector: 'app-sms-notification',
  templateUrl: './sms-notification.component.html',
  styleUrls: ['./sms-notification.component.scss']
})
export class SmsNotificationComponent {

  readonly smsHelpUrl = SMS_HELP_URL;

  constructor() { }
}
